(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["scroll-reveal-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-reveal-timeline')) {
    class ScrollRevealTimeline extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
        this.track = this.querySelector('[data-timeline-track]');
        this.icons = Array.from(this.querySelectorAll('.scroll-timeline__icon'));
        this.frame = null;
        this.update = this.update.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(this.update);
      }

      update() {
        this.frame = null;
        const viewportHeight = window.innerHeight;
        const clearLine = viewportHeight * 0.68;
        const fadeLine = viewportHeight * 0.94;
        const range = fadeLine - clearLine;

        this.items.forEach((item) => {
          const center = item.getBoundingClientRect().top + Math.min(item.offsetHeight * 0.25, 48);
          const progress = Math.max(0, Math.min(1, (fadeLine - center) / range));
          item.style.setProperty('--reveal-progress', progress.toFixed(3));
        });

        if (this.track && this.icons.length > 1) {
          const listRect = this.track.parentElement.getBoundingClientRect();
          const firstRect = this.icons[0].getBoundingClientRect();
          const lastRect = this.icons[this.icons.length - 1].getBoundingClientRect();
          const trackTop = firstRect.top + (firstRect.height / 2);
          const trackBottom = lastRect.top + (lastRect.height / 2);
          const trackHeight = Math.max(0, trackBottom - trackTop);
          const trackLeft = firstRect.left + (firstRect.width / 2);
          const progress = trackHeight > 0
            ? Math.max(0, Math.min(1, (clearLine - trackTop) / trackHeight))
            : 0;

          this.track.style.top = `${trackTop - listRect.top}px`;
          this.track.style.left = `${trackLeft - listRect.left - (this.track.offsetWidth / 2)}px`;
          this.track.style.height = `${trackHeight}px`;
          this.track.style.setProperty('--track-fill', progress.toFixed(3));
        }
      }
    }

    customElements.define('scroll-reveal-timeline', ScrollRevealTimeline);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["toe-align-bundle-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('toe-bundle-selector')) {
    class ToeBundleSelector extends HTMLElement {
      connectedCallback() {
        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);
        this.originalPrices = new Map();
        this.apply();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.restorePrices();
        this.toggleExpress(false);
      }

      onChange(event) {
        const target = event.target;
        if (target.classList.contains('ta-bundle__swatch-input')) {
          const tier3 = this.querySelector('.ta-bundle__radio[value="3"]');
          if (tier3 && !tier3.disabled) tier3.checked = true;
        }
        if (target.classList.contains('ta-bundle__radio') || target.classList.contains('ta-bundle__swatch-input')) {
          this.apply(true);
        }
      }

      get selected() {
        return this.querySelector('.ta-bundle__radio:checked');
      }

      get form() {
        const scope = this.closest('.shopify-section') || document;
        return scope.querySelector('form[data-type="add-to-cart-form"]') || scope.querySelector('form[action*="/cart/add"]');
      }

      apply(userInitiated = false) {
        const radio = this.selected;
        if (!radio) return;

        // Sync Tier 3 with its chosen option (colour).
        if (radio.value === '3') {
          const option = this.querySelector('.ta-bundle__swatch-input:checked');
          if (option) {
            radio.dataset.variantId = option.value;
            radio.dataset.price = option.dataset.price || radio.dataset.price;
            radio.dataset.compare = option.dataset.compare || '';
            radio.dataset.save = option.dataset.save || '';
          }
        }

        this.querySelectorAll('.ta-bundle__card').forEach((card) => {
          card.classList.toggle('is-selected', card.contains(radio));
        });

        const form = this.form;
        if (form) {
          const idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = radio.dataset.variantId;
          if (userInitiated) {
            const qty = form.querySelector('input[name="quantity"]');
            if (qty && qty.value !== '1') {
              qty.value = '1';
              qty.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }

        this.updatePrices(radio);
        this.toggleExpress(radio.value !== '1' && this.dataset.hideExpress === 'true');

        this.dispatchEvent(
          new CustomEvent('toe-bundle:change', {
            bubbles: true,
            detail: { tier: Number(radio.value), variantId: Number(radio.dataset.variantId) },
          })
        );
      }

      priceContainers() {
        const scope = this.closest('.shopify-section') || document;
        const containers = [...scope.querySelectorAll('product-price [ref="priceContainer"]')];
        document.querySelectorAll('.sticky-add-to-cart [ref="priceContainer"]').forEach((el) => containers.push(el));
        return containers;
      }

      updatePrices(radio) {
        this.priceContainers().forEach((container) => {
          if (!this.originalPrices.has(container)) this.originalPrices.set(container, container.innerHTML);
          if (radio.value === '1') {
            container.innerHTML = this.originalPrices.get(container);
            return;
          }
          const { price, compare, save } = radio.dataset;
          let html = '<span role="group"><span class="visually-hidden">Bundle price&nbsp;</span><span class="price"><span class="money">' + price + '</span></span></span>';
          if (compare) {
            html += '<span role="group"><span class="visually-hidden">Value if bought separately&nbsp;</span><span class="compare-at-price price--compare" style="margin-left: var(--margin-xs, 0.5rem);"><span class="money">' + compare + '</span></span></span>';
          }
          if (save && !container.closest('.sticky-add-to-cart')) {
            html += ' <span class="sale-badge color-scheme-1" role="status">Save ' + save + '</span>';
          }
          container.innerHTML = html;
        });
      }

      restorePrices() {
        if (!this.originalPrices) return;
        this.originalPrices.forEach((html, container) => {
          if (container.isConnected) container.innerHTML = html;
        });
        this.originalPrices.clear();
      }

      toggleExpress(hide) {
        const scope = this.closest('.shopify-section') || document;
        scope.querySelectorAll('.accelerated-checkout-block').forEach((el) => {
          el.toggleAttribute('hidden', hide);
          el.style.display = hide ? 'none' : '';
        });
      }
    }
    customElements.define('toe-bundle-selector', ToeBundleSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
